import ApiService from "@/common/services/http/api.service";

const DepartamentoService = {
  /**
   * Buscar os departamentos por clientes
   * @param clienteID id do cliente
   * @returns {*}
   */
  async getDepartamentoByClienteID(clienteID) {
    const { data: result } = await ApiService.get(
      "departamento/getbyclienteid",
      clienteID
    );

    return result;
  },
  async getDepartamentoByEmpresaID(empresaID, validarCadastroEntidade = false) {
    const { data: result } = await ApiService.get(
      "departamento/GetByDepartamentoPorEmpresaID",
      empresaID,
      { validarCadastroEntidade: validarCadastroEntidade }
    );

    return result;
  },

  async getDepartamentoByUsuarioID(validarCadastroEntidade = false) {
    const { data: result } = await ApiService.get(
      "departamento/GetByDepartamentoPorUsuarioID", null,
      { validarCadastroEntidade: validarCadastroEntidade }
    );

    return result;
  },
};

export default DepartamentoService;
